import axios from "axios";
import join from "url-join";

import Auth from "../common/firebase.auth";
import router from "../router";
import store from "../store";
// import TokenService from '../jwt.service';

const baseDomain = process.env.VUE_APP_URL;
const baseURL = `${baseDomain}/api`;

let httpClient = axios.create({
  baseURL
});

httpClient.interceptors.request.use(async config => {
  let headers = null;

  if (Auth.currentUser) {
    let token = await Auth.currentUser.getIdToken();
    headers = {
      authorization: `Bearer ${token}`
    };
  }

  if (headers) {
    config.headers = headers;
  }
  config.url = join(baseURL, config.url);
  return config;
});

httpClient.interceptors.response.use(
  async response => {
    return response;
  },
  error => {
    store.dispatch("setError", error);

    if (error.response.status === 401) {
      router.push("/login");
    }
    throw error;
  }
);

export default httpClient;
